module.exports = __webpack_public_path__ + "img/camelliaF.b5edbfd4.jpg";